import './WorksPage.css';
import { useState } from 'react';
import WorkRowCard from './WorkRowCard';
import WorkGridCard from './WorkGridCard';

import { useData } from '../DataProvider';

const WorksPage = () => {

    const MODE_GRID = 'grid'
    const MODE_TABLE = 'table'

    const [showMode, setShowMode] = useState(MODE_GRID);
    const { data, loading, toggleMuted } = useData();
    const [searchInput, setSearchInput] = useState("");
    const [searchTag, setSearchTag] = useState("All");

    function getMutedToggle(){
        return (
            <span className='default-text' style={{ paddingRight: '30px', userSelect: 'none', textDecoration: 'none', cursor: 'pointer' }} onClick={toggleMuted}>
                <img width={25} height={25} src={data.muted ? `muteonwhite.png` : `muteoffwhite.png`} alt='mute toggle'>
                </img>
            </span>
        );
    }

    function getGridViewSVG(color) {

        return (
            <span onClick={() => { setShowMode(MODE_GRID);  }} style = {{userSelect: 'none', textDecoration: 'none'}}>
                <svg className='mode-icon' xmlns="http://www.w3.org/2000/svg"
                    width="52" height="22" shapeRendering="crispEdges" fill={color} >
                    <path d="M0 0h1v1H0z" /><path d="M1 0h1v1H1z" /><path d="M2 0h1v1H2z" /><path d="M3 0h1v1H3z" /><path d="M4 0h1v1H4z" /><path d="M5 0h1v1H5z" /><path d="M6 0h1v1H6z" /><path d="M7 0h1v1H7z" /><path d="M8 0h1v1H8zm5 0h1v1h-1z" /><path d="M14 0h1v1h-1z" /><path d="M15 0h1v1h-1z" /><path d="M16 0h1v1h-1z" /><path d="M17 0h1v1h-1z" /><path d="M18 0h1v1h-1z" /><path d="M19 0h1v1h-1z" /><path d="M20 0h1v1h-1z" /><path d="M21 0h1v1h-1zM0 1h1v1H0zm8 0h1v1H8zm5 0h1v1h-1z" /><path d="M21 1h1v1h-1zM0 2h1v1H0zm8 0h1v1H8zm5 0h1v1h-1z" /><path d="M21 2h1v1h-1zM0 3h1v1H0zm8 0h1v1H8zm5 0h1v1h-1z" /><path d="M21 3h1v1h-1zM0 4h1v1H0zm8 0h1v1H8zm5 0h1v1h-1z" /><path d="M21 4h1v1h-1zM0 5h1v1H0zm8 0h1v1H8zm5 0h1v1h-1z" /><path d="M21 5h1v1h-1zM0 6h1v1H0zm8 0h1v1H8zm5 0h1v1h-1z" /><path d="M21 6h1v1h-1zM0 7h1v1H0zm8 0h1v1H8zm5 0h1v1h-1z" /><path d="M21 7h1v1h-1zM0 8h1v1H0z" /><path d="M1 8h1v1H1z" /><path d="M2 8h1v1H2z" /><path d="M3 8h1v1H3z" /><path d="M4 8h1v1H4z" /><path d="M5 8h1v1H5z" /><path d="M6 8h1v1H6z" /><path d="M7 8h1v1H7z" /><path d="M8 8h1v1H8zm5 0h1v1h-1z" /><path d="M14 8h1v1h-1z" /><path d="M15 8h1v1h-1z" /><path d="M16 8h1v1h-1z" /><path d="M17 8h1v1h-1z" /><path d="M18 8h1v1h-1z" /><path d="M19 8h1v1h-1z" /><path d="M20 8h1v1h-1z" /><path d="M21 8h1v1h-1zM0 13h1v1H0z" /><path d="M1 13h1v1H1z" /><path d="M2 13h1v1H2z" /><path d="M3 13h1v1H3z" /><path d="M4 13h1v1H4z" /><path d="M5 13h1v1H5z" /><path d="M6 13h1v1H6z" /><path d="M7 13h1v1H7z" /><path d="M8 13h1v1H8zm5 0h1v1h-1z" /><path d="M14 13h1v1h-1z" /><path d="M15 13h1v1h-1z" /><path d="M16 13h1v1h-1z" /><path d="M17 13h1v1h-1z" /><path d="M18 13h1v1h-1z" /><path d="M19 13h1v1h-1z" /><path d="M20 13h1v1h-1z" /><path d="M21 13h1v1h-1zM0 14h1v1H0zm8 0h1v1H8zm5 0h1v1h-1z" /><path d="M21 14h1v1h-1zM0 15h1v1H0zm8 0h1v1H8zm5 0h1v1h-1z" /><path d="M21 15h1v1h-1zM0 16h1v1H0zm8 0h1v1H8zm5 0h1v1h-1z" /><path d="M21 16h1v1h-1zM0 17h1v1H0zm8 0h1v1H8zm5 0h1v1h-1z" /><path d="M21 17h1v1h-1zM0 18h1v1H0zm8 0h1v1H8zm5 0h1v1h-1z" /><path d="M21 18h1v1h-1zM0 19h1v1H0zm8 0h1v1H8zm5 0h1v1h-1z" /><path d="M21 19h1v1h-1zM0 20h1v1H0zm8 0h1v1H8zm5 0h1v1h-1z" /><path d="M21 20h1v1h-1zM0 21h1v1H0z" /><path d="M1 21h1v1H1z" /><path d="M2 21h1v1H2z" /><path d="M3 21h1v1H3z" /><path d="M4 21h1v1H4z" /><path d="M5 21h1v1H5z" /><path d="M6 21h1v1H6z" /><path d="M7 21h1v1H7z" /><path d="M8 21h1v1H8zm5 0h1v1h-1z" /><path d="M14 21h1v1h-1z" /><path d="M15 21h1v1h-1z" /><path d="M16 21h1v1h-1z" /><path d="M17 21h1v1h-1z" /><path d="M18 21h1v1h-1z" /><path d="M19 21h1v1h-1z" /><path d="M20 21h1v1h-1z" /><path d="M21 21h1v1h-1z" />
                </svg>
            </span>
        )
    }

    function getTableViewSVG(color) {
        return (
            <span onClick={() => setShowMode(MODE_TABLE)} style = {{userSelect: 'none', textDecoration: 'none'}}>
                <svg className='mode-icon' xmlns="http://www.w3.org/2000/svg"
                    width="52" height="22" shapeRendering="crispEdges" fill={color} >
                    <path d="M0 6h1v1H0z" /><path d="M1 6h1v1H1z" /><path d="M2 6h1v1H2z" /><path d="M3 6h1v1H3z" /><path d="M4 6h1v1H4z" /><path d="M5 6h1v1H5z" /><path d="M6 6h1v1H6z" /><path d="M7 6h1v1H7z" /><path d="M8 6h1v1H8z" /><path d="M9 6h1v1H9z" /><path d="M10 6h1v1h-1z" /><path d="M11 6h1v1h-1z" /><path d="M12 6h1v1h-1z" /><path d="M13 6h1v1h-1z" /><path d="M14 6h1v1h-1z" /><path d="M15 6h1v1h-1z" /><path d="M16 6h1v1h-1z" /><path d="M17 6h1v1h-1z" /><path d="M18 6h1v1h-1z" /><path d="M19 6h1v1h-1z" /><path d="M20 6h1v1h-1z" /><path d="M21 6h1v1h-1zM0 7h1v1H0z" /><path d="M1 7h1v1H1z" /><path d="M2 7h1v1H2z" /><path d="M3 7h1v1H3z" /><path d="M4 7h1v1H4z" /><path d="M5 7h1v1H5z" /><path d="M6 7h1v1H6z" /><path d="M7 7h1v1H7z" /><path d="M8 7h1v1H8z" /><path d="M9 7h1v1H9z" /><path d="M10 7h1v1h-1z" /><path d="M11 7h1v1h-1z" /><path d="M12 7h1v1h-1z" /><path d="M13 7h1v1h-1z" /><path d="M14 7h1v1h-1z" /><path d="M15 7h1v1h-1z" /><path d="M16 7h1v1h-1z" /><path d="M17 7h1v1h-1z" /><path d="M18 7h1v1h-1z" /><path d="M19 7h1v1h-1z" /><path d="M20 7h1v1h-1z" /><path d="M21 7h1v1h-1zM0 14h1v1H0z" /><path d="M1 14h1v1H1z" /><path d="M2 14h1v1H2z" /><path d="M3 14h1v1H3z" /><path d="M4 14h1v1H4z" /><path d="M5 14h1v1H5z" /><path d="M6 14h1v1H6z" /><path d="M7 14h1v1H7z" /><path d="M8 14h1v1H8z" /><path d="M9 14h1v1H9z" /><path d="M10 14h1v1h-1z" /><path d="M11 14h1v1h-1zM0 15h1v1H0z" /><path d="M1 15h1v1H1z" /><path d="M2 15h1v1H2z" /><path d="M3 15h1v1H3z" /><path d="M4 15h1v1H4z" /><path d="M5 15h1v1H5z" /><path d="M6 15h1v1H6z" /><path d="M7 15h1v1H7z" /><path d="M8 15h1v1H8z" /><path d="M9 15h1v1H9z" /><path d="M10 15h1v1h-1z" /><path d="M11 15h1v1h-1z" />
                </svg>
            </span>
        );
    }

    function workGrid(data) {
        const audio = document.getElementById(`${data['title']}`);
        return (<WorkGridCard data={data} audio={audio}/>);
    }

    function workRow(data) {
        const audio = document.getElementById(`${data['title']}`);
        return (<WorkRowCard data={data} audio={audio}/>);
    }


    function workFilter(item) {
        let itemSearchTag = item['search-tag'];

        if (searchInput) {
            if (itemSearchTag.includes(searchInput))
                return true;
            else
                return false;
        }

        if (searchTag === 'All')
            return true;

        if (itemSearchTag === searchTag)
            return true;

        return false;
    }

    function renderPage() {
        if (showMode === MODE_GRID)
            return (
                <div className='grid-container'>
                    {data.works.filter(workFilter).map(item => workGrid(item))}
                </div>);
        else if (showMode === MODE_TABLE)
            return (<div className='center-div'>
                <table className='table-style'>
                    <thead className='table-header'>
                        <tr style={{ borderTop: 'none' }}>
                            <th className='default-text grey-text' scope="col">Song</th>
                            <th className='default-text grey-text' scope="col">Genre</th>
                            <th className='default-text grey-text' scope="col">Published Date</th>
                            <th className='default-text grey-text' scope="col">Running Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.works.filter(workFilter).map(item => workRow(item))}
                    </tbody>
                </table>
            </div>);
    }

    function showButtons() {
        if (showMode === MODE_GRID)
            return (
                <div className='mode-select'>
                    {getMutedToggle()}
                    {getGridViewSVG('white')}
                    {getTableViewSVG('grey')}
                </div>
            );
        else if (showMode === MODE_TABLE)
            return (
                <div className='mode-select'>
                    {getMutedToggle()}
                    {getGridViewSVG('grey')}
                    {getTableViewSVG('white')}
                </div>
            );
    }

    function createSearchButton(tag) {
        var style = { paddingLeft: '25px', color: 'grey',userSelect: 'none', textDecoration: 'none', cursor: 'pointer' }
        if (searchTag === tag)
            style = { paddingLeft: '25px', color: 'white',userSelect: 'none', textDecoration: 'none', cursor: 'pointer' }
        return <span className='default-text' style={style} onClick={() => { setSearchTag(tag) }}>{tag}</span>
    }

    function createAllButton() {
        var style = { color: 'grey' ,userSelect: 'none', textDecoration: 'none', cursor: 'pointer'  }
        if (searchTag === 'All' && !searchInput)
            style = { color: 'white' ,userSelect: 'none', textDecoration: 'none', cursor: 'pointer'  }
        return <span className='default-text' style={style} onClick={() => {
            setSearchTag('All');
            // document.getElementById('genre-search').value = ''
            setSearchInput('');
        }}>All</span>
    }


    function createSearchBar() {
        let tags = new Set();
        data.works.forEach(element => {
            tags.add(element['search-tag'])
        });

        return (<span>
            <span className='scroll-mobile'>
                {createAllButton()}
                <span className='default-text' style={{ paddingLeft: '25px',userSelect: 'none' }}>|</span>
                {/* <input id='genre-search' className='default-text hide-mobile' onChange={e => setSearchInput(e.target.value)} style={{paddingLeft: '25px', backgroundColor: 'rgba(0,0,0,0)', outline: 'none', border: 'none',color: 'white'}} placeholder='Search by Genre'></input> */}
                {[...tags].map(item => createSearchButton(item))}
                <span className='show-mobile' style={{ paddingRight: '25px' }}></span>
            </span>
        </span>)
    }



    if (loading) {
        return <div></div>;
    }

    return (
        <div>
            <div className='genre-search'>
                {createSearchBar()}
            </div>
            {showButtons()}
            <div className='mode-select-gap'></div>
            <div className='line-nm'></div>
            {renderPage()}
        </div>
    );
}

export default WorksPage;
